import type { RememberVisitorValue } from '@elfsight/configurator-contracts';

export const getRememberVisitorValue = (
  controlValue: RememberVisitorValue | undefined
): number => {
  if (controlValue?.value === 'custom') {
    return controlValue.customNumber * controlValue.customPeriod * 1000;
  }

  if (controlValue?.value === -1) {
    return -1;
  }

  return Number(controlValue?.value) * 1000;
};
